<template>
  <AisSortBy
    :items="props.items"
    class="FilterSort"
  >
    <template #default="{ items, refine }">
      <div class="FilterSort__wrapper">
        <VisionIcon
          icon="order"
          size="x-small"
          colour="black"
        />
        <select
          id="filter-sort"
          class="FilterSort__select"
          @change="
            refine($event.target?.value), handleChange($event.target?.value)
          "
        >
          <option
            v-for="item in items"
            :key="item.value"
            :value="item.value"
          >
            {{ item.displayValue }}
          </option>
        </select>
      </div>
    </template>
  </AisSortBy>
</template>

<script setup lang="ts">
interface SortItem {
  value: string
  label: string
}

interface Props {
  items: SortItem[]
}

const { $track } = useNuxtApp()

const props = defineProps<Required<Props>>()

function handleChange(value: string) {
  $track.filter.sort({
    sortedBy: value,
    numberOfOptions: props.items.length,
  })
}
</script>

<style lang="postcss" scoped>
.FilterSort {
  @apply heading-3 md:text-sm md:font-bold;

  @screen xl {
    @apply heading-4;
  }
}
.FilterSort__wrapper {
  @apply flex items-center gap-x-2;

  @screen lgMax {
    @apply global-wrapper;
  }
}

.FilterSort__select {
  @apply w-full py-5 bg-white text-off-black appearance-none leading-none cursor-pointer whitespace-nowrap text-ellipsis lg:w-28;
}
</style>
